webpackJsonp([247831265026177],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactstrap = __webpack_require__(30);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _myTitle = __webpack_require__(12);
	
	var _myTitle2 = _interopRequireDefault(_myTitle);
	
	var _blockCover = __webpack_require__(17);
	
	var _blockCover2 = _interopRequireDefault(_blockCover);
	
	var _contact = __webpack_require__(57);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _data = __webpack_require__(45);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Architecte = function Architecte() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Architectes, partenaires : \xE9tudions notre prochaine collaboration'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Nous travaillons en totale harmonie avec vos \xE9quipes dans la ma\xEEtrise parfaite de notre m\xE9tier.' })
	    ),
	    _react2.default.createElement(_blockCover2.default, {
	      backgroundUrl: _contact2.default,
	      title: 'Je suis architecte',
	      repeatedTitle: true }),
	    _react2.default.createElement(
	      _block2.default,
	      { hasDecoration: true, className: 'block-grey-background' },
	      _react2.default.createElement(
	        _myTitle2.default,
	        null,
	        'J\'ai un projet'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'light fs-16 lh-23 text-align-center mb-4' },
	        'Didier Br\xE9 travaille en parfaite harmonie avec des',
	        _react2.default.createElement('br', null),
	        'architectes et des partenaires de renom, pour cr\xE9er',
	        _react2.default.createElement('br', null),
	        'ensemble les meubles qui vous ressemblent.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-md-center mb-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row no-gutters' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 text-align-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'bold fs-16 mb-0' },
	                'Les architectes :'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.santillane-design.com/', target: '_blank', className: 'color-red light fs-16 mb-0' },
	                'Santillane Design'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                { className: 'color-red light fs-16 mb-0' },
	                'St\xE9phanie Favre-Winkler'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'color-red light fs-16 mb-0' },
	                'Halabama J. Luc Baussant'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 text-align-center' },
	              _react2.default.createElement(
	                'p',
	                { className: 'bold fs-16 mb-0' },
	                'Les partenaires :'
	              ),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.laparqueterienouvelle.fr/', target: '_blank', className: 'color-red light fs-16 mb-0' },
	                'La Parqueterie Nouvelle'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.lmcstore.com/fr/', target: '_blank', className: 'color-red light fs-16 mb-0' },
	                'LMC Store'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Form,
	        { method: 'post', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field', name: 'architecte' },
	        _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'architecte' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'hidden' },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Don\u2019t fill this out: ',
	            _react2.default.createElement('input', { name: 'bot-field' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-md-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-5' },
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'cabinet', id: 'cabinet', placeholder: 'Cabinet' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'name', id: 'name', placeholder: 'Nom, pr\xE9nom' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(_reactstrap.Input, { type: 'email', name: 'email', id: 'email', placeholder: 'Adresse email' })
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Input,
	                { type: 'select', name: 'project', id: 'project' },
	                _react2.default.createElement(
	                  'option',
	                  { disabled: true, selected: true },
	                  'Projet'
	                ),
	                _data2.default.default.map(function (item, index) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: index, value: item.title },
	                    item.title
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              null,
	              _react2.default.createElement(
	                _reactstrap.InputGroup,
	                null,
	                _react2.default.createElement(_reactstrap.Input, { placeholder: 'Zone g\xE9ographique du chantier', type: 'text' }),
	                _react2.default.createElement(
	                  _reactstrap.InputGroupAddon,
	                  null,
	                  _react2.default.createElement('img', { src: '/locate.svg', alt: 'Localisation' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.FormGroup,
	              { row: true },
	              _react2.default.createElement(
	                _reactstrap.Label,
	                { 'for': 'date', sm: 6 },
	                'Date estim\xE9e du projet :'
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { sm: 6 },
	                _react2.default.createElement(_reactstrap.Input, { type: 'date', name: 'date', id: 'date', placeholder: 'JJ/MM/AAAA' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-align-center' },
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary btn-big btn-min-width-300 mt-3' },
	                'Envoyer'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'color-grey fs-12 light mt-3 text-align-center' },
	              '* D\xE9lai de r\xE9ponse sous 72h'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Architecte;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-architecte-js-3fc39d16130cc513245c.js